<template>
  <div class="popup_mask" @click.self="Hidden">
    <div class="popup_login">
      <!--      <div class="popup_login_ewm"><img src="../assets/img/ewm.jpg" alt=""></div>-->
      <div class="popup_login_type">
        <a href="#" v-if="navFlag === 'login'" :class="typeFlag?'popup_login_type_active':''" @click="typeSwitch(true)">账号登录</a>
        <a href="#" v-if="navFlag === 'login'" :class="!typeFlag?'popup_login_type_active':''"
           @click="typeSwitch(false)">手机验证码登录</a>
        <a href="#" v-if="navFlag === 'register'" class="popup_login_type_active">注册</a>
        <a href="#" v-if="navFlag === 'retrieve'" class="popup_login_type_active">找回密码</a>
        <a href="#" v-if="navFlag === 'thirdParty'" class="popup_login_type_active">绑定手机号及设置登录密码</a>
        <a href="#" v-if="navFlag === 'thirdPartyCon'" class="popup_login_type_active">该手机号已绑定以下{{thirdPartyId===1?"QQ":thirdPartyId===2?"微信":"微博"}}账号</a>
      </div>
      <!--账号密码登录-->
      <div class="login_type_user" v-if="navFlag==='login'" v-show="typeFlag">
        <label for="loginName"><input type="text" id="loginName" v-model="ruleForm.userName" class="popup_login_input"  placeholder="手机号"></label>
        <label for="loginPassword"><input :type="inputType?'password':'text'" id="loginPassword"
                                          v-model="ruleForm.userPwd"
                                          @keyup.enter="login" @input="alertClear" class="popup_login_input"
                                          placeholder="密码"></label>
        <div class="login_alert" v-if="ruleForm.errMsg">{{ruleForm.errMsg}}</div>
        <div class="login_open" @click="passwdOpen"><i  :class="inputType?'iconfont icon-biyan':'iconfont icon-yanjing'"></i></div>
        <div :class="['popup_login_button',ruleForm.userName.length>0?'popup_login_button_active':'']" @click="login">登录</div>
      </div>
      <!--带验证码登录-->
      <div class="login_type_phone" v-show="!typeFlag || navFlag==='register' || navFlag==='retrieve' || navFlag === 'thirdParty'">
        <label for="loginPhone"><input type="text" id="loginPhone" v-model="registered.userPhone"
                                       class="popup_login_input"
                                       @keyup="loginPhoneInput" maxlength="11" placeholder="请输入手机号"></label>
        <div class="loginCodeInfo" v-if="loginPhoneInfo">{{loginPhoneInfo}}</div>
        <label for="loginCode"><input type="text" v-model="identifyCodeInput" @keyup="loginCodeInput" maxlength="4" id="loginCode" class="popup_login_input W240" placeholder="验证码"></label>
        <div class="loginCodeRefresh" @click="refreshCode"><!-- <i class="iconfont icon-shuaxin"></i> --> <img src="https://yjy.goodwebuy.cn/rmzd/assets/img/refreshCode.png"> </div>

        <div class="loginCodeImg">
          <SIdentify :identifyCode="identifyCode"></SIdentify>
        </div>
        <div style="clear: both;"></div>
        <div class="loginCodeInfo" v-if="loginCodeInfo">{{loginCodeInfo}}</div>
        <label for="loginPhoneCode" v-if="phoneCode"><input type="text" id="loginPhoneCode" v-model="registered.userCode" class="popup_login_input W333" placeholder="请输入短信验证码"></label>
        <div class="loginPhoneCodeNum" v-if="phoneCode" @click="getCode" :style="getCodeFlag?'':'color:#DE0005;'">{{getCodeInfo}}</div>
        <div class="loginCodeInfo" v-if="phoneCode && registered.errMsg">{{registered.errMsg}}</div>
        <label for="loginPwd" v-if="phoneCode && navFlag!=='login'">
          <input @input="passwdRule" type="password" id="loginPwd" v-model="registered.passwd" class="popup_login_input" minlength="6" maxlength="16" placeholder="密码  6-16位数字或字母">
        </label>

        <div :class="['popup_login_button',registered.userPhone>0?'popup_login_button_active':'']" @click="loginCode">{{navFlag === 'login'?'登录':navFlag ==='thirdParty'?'确认绑定并登录':navFlag ==='register'?'注册':'重置密码'}}
        </div>
        <!-- <div :class="['popup_login_button_login',registered.userPhone>0?'popup_login_button_active':'']" v-if="navFlag !== 'login'&& navFlag !== 'thirdParty'" @click="navFlagFn('login')"><a href="#">直接登录</a></div> -->

      </div>
      <!--第三方重复绑定-->
      <div class="login_type_thirdParty" v-if="navFlag==='thirdPartyCon'">
        <div class="thirdParty_icon"><img :src="user.headIcon" alt=""></div>
        <div class="thirdParty_nickName">{{user.nickName}}</div>
        <div class="thirdParty_info">是否重新绑定到当前{{thirdPartyId===1?"QQ":thirdPartyId===2?"微信":"微博"}}账号</div>
        <div class="popup_login_button" @click="thirdPartyBtn(true)">是</div>
        <div class="popup_login_button" @click="thirdPartyBtn(false)">否</div>
      </div>

      <div class="popup_login_info" v-if="navFlag === 'login'"><!--<span></span>下次自动登录-->
        <a href="#" @click="navFlagFn('register')">注册</a>
        <a href="#" @click="navFlagFn('retrieve')">忘记密码</a>
      </div>
     <!-- <div class="popup_login_title" v-if="navFlag !== 'thirdParty' && navFlag !== 'thirdPartyCon' || thirdPartyFlag">第三方账号登录</div>
      <div class="popup_login_list" v-if="navFlag !== 'thirdParty' && navFlag !== 'thirdPartyCon' || thirdPartyFlag">
        <a @click="openUrl(1)"><i class="iconfont icon-wchart"></i></a>
        <a @click="openUrl(2)"><i class="iconfont icon-weibo"></i></a>
        <a @click="openUrl(3)"><i class="iconfont icon-QQ"></i></a>
      </div> -->
      <div class="agreen">登录/注册即表示你同意<a href="http://view.officeapps.live.com/op/view.aspx?src=http%3A%2F%2Ffile.xn--blqqdv68hqdiyvmnobx96a.com%2Ffile%2FmediaNo%2Fuser_protocal.docx" target="_blank">《用户协议》</a>和<a href="http://view.officeapps.live.com/op/view.aspx?src=http%3A%2F%2Ffile.xn--blqqdv68hqdiyvmnobx96a.com%2Ffile%2FmediaNo%2Fuser_private.docx" target="_blank">《隐私政策》</a></div>
    </div>
  </div>
</template>

<script>
  //登录弹窗
  import {userLogin, userLoginPhone, sendPhone, bindNew,userInfo} from "@/api";
  import SIdentify from '@/components/identify.vue'
  import {mapActions} from "vuex"
  import {setStore, getStore} from "@/utils/storage";
  import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';

  let timer;
  let timer01;
  export default {
    name: "PopupLogin",
    data() {
      return {
        typeFlag: true,
        navFlag: 'login',
        userPlatformId: '',  //第三方登录未绑定手机号
        ruleForm: {
          userName: '',
          userPwd: '',
          errMsg: ''
        },
        getCodeFlag: true,
        getCodeInfo: '获取短信验证码',
        registered: {
          userPhone: '',
          userCode: '',
          passwd: '',
          errMsg: ''
        },
        inputType: true,
        identifyCodeInput: '',
        identifyCodes: '1234567890',
        identifyCode: '',
        loginPhoneInfo: '',
        loginCodeInfo: '',
        phoneCode: false,
        wbBtn: '<wb:login-button type="6,1" onlogin="login" onlogout="logout">登录按钮</wb:login-button>',
        thirdPartyId: '',
        token: '',
        user: {},
        thirdPartyFlag:false
      }
    },

    components: {
      SIdentify
    },

    mounted() {
      // 验证码初始化
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4)
    },

    methods: {
      ...mapActions(['POPUP_LOGIN', 'USER_SIGNIN', 'USER_SIGNOUT','UPDATE_USER']),

      //关闭登录窗口
      Hidden() {
        this.POPUP_LOGIN(false);
        this.ruleForm = {
          userName: '',
          userPwd: '',
          errMsg: ''
        };
        this.registered = {
          userPhone: '',
          userCode: '',
          passwd: '',
          errMsg: ''
        };
        this.identifyCodeInput = '';
        this.phoneCode = false;
        this.navFlagFn('login');
        clearInterval(timer01);
        this.thirdPartyFlag = false;
      },

      //切换登录方式
      typeSwitch(_flag) {
        this.typeFlag = _flag
      },

      //切换登录窗口显示状态
      navFlagFn(_nav) {
        this.navFlag = _nav
      },

      //密码规则
      passwdRule(e){
        let reg = /^[a-zA-Z\d]+$/;
        if(!reg.test(e.data)){
          this.registered.passwd = this.registered.passwd.replace(e.data,'');
        }
      },

      //手机号/密码登录
      login() {
        const {userName, userPwd} = this.ruleForm;
        if (!userName || !userPwd) {
          this.ruleForm.errMsg = '账号或密码不能为空'
        } else {
          let params = {phone: userName, passwd: userPwd, loginType: 2};
          userLoginPhone(params).then(res => {
            if (!res.code) {
              this.USER_SIGNIN({token: res.info.token, user: JSON.stringify(res.info.user)});
              this.Hidden();
              this.user=res.info.user;
              window.localStorage.setItem('id',this.user.id);
              window.localStorage.setItem('loginName',this.user.loginName);
              window.localStorage.setItem('focusNum',this.user.focusNum);
              window.localStorage.setItem('fansNum',this.user.fansNum);
              window.localStorage.setItem('topicNum',this.user.topicNum);
              window.localStorage.setItem('readNum',this.user.readNum);
              window.localStorage.setItem('discussNum',this.user.discussNum);
              window.localStorage.setItem('mediano',this.user.mediaNo);
              window.localStorage.setItem('mediaNo',this.user.mediaNo);
              window.localStorage.setItem('officeTag',this.user.officeTag);
              window.localStorage.setItem('mediaNoType',this.user.mediaNoType);
              window.localStorage.setItem('mediaNoAudit',this.user.mediaNoAudit);
              window.localStorage.setItem('uname',this.user.uname);
              this.$snotify.success('登录成功！');
              userInfo().then(res => {
                if(!res.code){
                  this.UPDATE_USER({user:JSON.stringify(res.info.user)})
                }
              });
            } else {
              this.ruleForm.errMsg = res.msg
            }
          })
        }
      },

      // 需要发送短信验证码的登录操作/手机验证码登录/注册/找回密码/第三方登录绑定手机号
      loginCode() {
        const {userPhone, userCode, passwd} = this.registered;
        if (!userPhone) {
          this.registered.errMsg = '手机号不能为空'
        } else if (!userCode) {
          this.registered.errMsg = '验证码不能为空'
        } else if (!passwd && this.navFlag !== 'login') {
          this.registered.errMsg = '密码不能为空'
        } else {
          this.registered.errMsg = '';
          let params = {phone: userPhone, code: userCode, passwd: passwd};
          if (this.userPlatformId && this.navFlag === 'thirdParty') {
            params.userPlatformId = this.userPlatformId;
            params.loginType = 4;
          }
          if (this.navFlag === 'retrieve') {
            params.loginType = 1
          }
          if (this.navFlag === 'register') {
            params.loginType = 3
          }
          userLoginPhone(params).then(res => {
            if (!res.code) {
              if (typeof res.info.existOtherTag !== 'undefined' && res.info.existOtherTag) {
                this.navFlagFn('thirdPartyCon');
                this.typeFlag = true;
                this.thirdPartyId = res.info.otherType;
                this.token = res.info.token;
                this.userPlatformId = JSON.parse(getStore('thirdPartyLogin')).info.userPlatformId;
                this.user = res.info.user;
                this.USER_SIGNIN({token: res.info.token, user: JSON.stringify(res.info.user)});

                this.thirdPartyFlag = false;
              } else {
                this.user = res.info.user;
                this.USER_SIGNIN({token: res.info.token, user: JSON.stringify(res.info.user)});
                this.Hidden();
              }

              window.localStorage.setItem('id',this.user.id);
              window.localStorage.setItem('loginName',this.user.loginName);
              window.localStorage.setItem('focusNum',this.user.focusNum);
              window.localStorage.setItem('fansNum',this.user.fansNum);
              window.localStorage.setItem('topicNum',this.user.topicNum);
              window.localStorage.setItem('readNum',this.user.readNum);
              window.localStorage.setItem('discussNum',this.user.discussNum);
              window.localStorage.setItem('mediano',this.user.mediaNo);
              window.localStorage.setItem('mediaNo',this.user.mediaNo);
              window.localStorage.setItem('officeTag',this.user.officeTag);
              window.localStorage.setItem('mediaNoType',this.user.mediaNoType);
              window.localStorage.setItem('mediaNoAudit',this.user.mediaNoAudit);
              window.localStorage.setItem('uname',this.user.uname);
              this.$snotify.success('登录成功！');
              userInfo().then(res => {
                if(!res.code){
                  this.UPDATE_USER({user:JSON.stringify(res.info.user)})
                }
              });
            } else {
              // this.ruleForm.errMsg = res.msg;
              this.loginCodeInfo = res.msg
            }
          })
        }
      },

      //清除提示文案
      alertClear() {
        this.ruleForm.errMsg = ''
      },

      // 生成随机数
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min)
      },

      // 切换验证码
      refreshCode() {
        this.identifyCode = '';
        this.makeCode(this.identifyCodes, 4);
        this.phoneCode = false;
        this.loginCodeInfo = '';
        this.identifyCodeInput = ''
      },

      // 生成四位随机验证码
      makeCode(o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[
            this.randomNum(0, this.identifyCodes.length)
            ]
        }
      },

      //手机号自定义验证规则
      loginPhoneInput() {
        if (this.registered.userPhone.length === 11) {
          let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
          if (!myreg.test(this.registered.userPhone)) {
            this.loginPhoneInfo = '请输入正确手机号码'
          } else {
            this.loginPhoneInfo = '';
            this.loginCodeInput()
          }
        }
      },

      //验证码自定义验证规则
      loginCodeInput() {
        if (this.identifyCodeInput.length === 4) {
          if (this.identifyCodeInput === this.identifyCode) {
            if (!this.registered.userPhone || !/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.registered.userPhone)) {
              this.loginPhoneInfo = '请输入正确手机号码'
            } else {
              this.phoneCode = true;
              // this.loginCodeInfo = '获取短信验证码'
              this.loginCodeInfo = ''
            }
          } else {
            this.phoneCode = false;
            this.loginCodeInfo = '验证码错误'
          }
        }
      },

      //获取短信验证码
      getCode() {
        if (this.getCodeFlag) {
          this.getCodeTime(59);
          sendPhone({phone: this.registered.userPhone}).then(res => {
            if (!res.code) {
              // console.log(res);
            }
          });
          this.getCodeFlag = false;
        }

      },
      //获取短信验证码计时
      getCodeTime(_time) {
        let num = _time;
        this.getCodeInfo = num + '秒后重发';
        timer = setInterval(() => {
          num--;
          this.getCodeInfo = num + '秒后重发';
          if (num <= 0) {
            clearInterval(timer);
            this.getCodeInfo = '获取短信验证码';
            this.getCodeFlag = true
          }
        }, 1000)

      },
      //密码是否可见
      passwdOpen() {
        this.inputType = !this.inputType;
      },
      //第三方登录授权弹窗
      openUrl(_type) {
        this.timerCallback();
        if (_type === 1) {
          window.open('https://open.weixin.qq.com/connect/qrconnect?appid=wxdeaaf140edf65922&redirect_uri=http%3a%2f%2fwww.xn--blqqdv68hqdiyvmnobx96a.com%2fthirdparty?type=1&response_type=code&scope=snsapi_login#wechat_redirect', '_blank', 'width=800,height=600,menubar=no,toolbar=no,status=no,scrollbars=yes')
        }
        if (_type === 2) {
          window.open('https://api.weibo.com/oauth2/authorize?client_id=2631106226&response_type=code&redirect_uri=http://www.xn--blqqdv68hqdiyvmnobx96a.com/thirdparty?type=2', '_blank', 'width=800,height=600,menubar=no,toolbar=no,status=no,scrollbars=yes')
        }
        if (_type === 3) {
          window.open('https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101793415&redirect_uri=http://www.xn--blqqdv68hqdiyvmnobx96a.com/thirdparty?type=3', '_blank', 'width=800,height=600,menubar=no,toolbar=no,status=no,scrollbars=yes')
        }
      },
      //定时回调监听授权操作
      timerCallback() {
        clearInterval(timer01);
        setStore('thirdPartyLogin', '');
        let loginRes = '';
        timer01 = setInterval(() => {
          if (getStore('thirdPartyLogin')) {
            loginRes = JSON.parse(getStore('thirdPartyLogin'));
            clearInterval(timer01);
            if (!loginRes.code) {
              if (typeof loginRes.info.token !== 'undefined') {
                this.USER_SIGNIN({token: loginRes.info.token, user: JSON.stringify(loginRes.info.user)});
                this.Hidden();
              } else if (loginRes.info.userPlatformId) {
                this.userPlatformId = loginRes.info.userPlatformId;
                this.navFlagFn('thirdParty');
              }
            }
          }
        }, 500);
      },
      //第三方重新覆盖绑定账号
      thirdPartyBtn(_flag) {
        if (_flag) {
          bindNew({
            accountType: this.thirdPartyId,
            token: this.token,
            userPlatformId: this.userPlatformId
          }).then(res => {
            if (!res.code) {
              this.Hidden();
            }
          })
        } else {
          this.USER_SIGNOUT();
          this.navFlagFn('thirdParty');
          this.thirdPartyFlag = true;
          this.refreshCode();
          this.identifyCodeInput = '';
          this.ruleForm = {
            userName: '',
            userPwd: '',
            errMsg: ''
          };
          this.registered = {
            userPhone: '',
            userCode: '',
            passwd: '',
            errMsg: ''
          };
        }
      }

    },
    beforeDestroy() {
      clearInterval(timer);
      clearInterval(timer01);
    }
  }
</script>

<style scoped>
  .login_type_user, .login_type_phone, .login_type_thirdParty {
    position: relative;
  }

  .W240 {
    width: 202px !important;
  }

  .W333 {
    width: 202px !important;
  }

  .thirdParty_icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    background-color: black;
    float: left;
  }

  .thirdParty_icon img {
    width: 100%;
    height: 100%;
  }

  .thirdParty_nickName {
    width: 360px;
    height: 80px;
    line-height: 80px;
    color: #333333;
    font-size: 22px;
    text-align: left;
    margin-left: 120px;
    /*float: left;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .thirdParty_info {
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #666666;
    font-size: 20px;
    text-align: left;
    margin-top: 20px;
  }

  .loginCodeImg {
    width: 154px;
    height: 58px;
    float: right;
    margin-left: 16px;
    margin-top: 30px;
    background-color: black;
    border-radius: 5px;
    overflow: hidden;
  }

  .loginCodeRefresh {
    width: 28px;
    height: 25px;
    float: right;
    margin-left: 0;
    margin-top: 44px;
    padding-left: 10px;
    line-height: 25px;
    text-align: right;
    cursor: pointer;
  }
  .loginCodeRefresh img{
    width: 100%;
  }

  .loginCodeRefresh i {
    font-size: 46px;
    color: #999999;
  }

  .loginPhoneCodeNum {
    width: 190px;
    height: 58px;
    text-align: left;
    float: right;
    color: #8F8F8F;
    font-size: 20px;
    /* border-radius: 5px; */
    /* border: 1px solid #e63b3b; */
    line-height: 58px;
    margin-left: 16px;
    cursor: pointer;
    margin-top: 30px;
  }

  .loginCodeInfo {
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: right;
    font-size: 16px;
    color: #DF0006;
    position: absolute;
  }

  .login_alert {
    position: absolute;
    width: auto;
    height: 58px;
    text-align: right;
    color: #f45252;
    font-size: 14px;
    line-height: 58px;
    bottom: 90px;
    right: 0;
    padding-right: 60px;
  }

  .login_open {
    position: absolute;
    width: 50px;
    height: 58px;
    line-height: 58px;
    text-align: right;
    color: #666666;
    font-size: 18px;
    bottom: 90px;
    right: 0;
    padding-right: 20px;
    cursor: pointer;
  }

  .login_open i {
    font-size: 25px;
  }

  .popup_mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 6;
  }

  .popup_login {
    position: fixed;
    width: 500px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    z-index: 6;
    box-sizing: border-box;
    padding: 20px 44px;
    border-radius: 5px;
  }

  .popup_login_ewm {
    position: absolute;
    width: 66px;
    height: 65px;
    top: 12px;
    right: 12px;
  }

  .popup_login_ewm img {
    width: 100%;
    height: 100%;
  }

  .popup_login_type {
    width: 100%;
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 8px;
  }

  .popup_login_type a {
    display: block;
    height: 100%;
    font-size: 20px;
    color: #969595;
    margin-right: 68px;
    float: left;
    cursor: pointer;
  }

  .popup_login_type_active {
    color: #DF0006 !important;
    border-bottom: 2px solid #DF0006;
  }

  .popup_login_input {
    width: 100%;
    height: 54px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    background-color: #ededed;
    box-sizing: border-box;
    padding: 25px;
    color: #BBBBBB;
    font-size: 16px;
    margin-top: 32px;
  }

  .popup_login_button {
    width: 100%;
    height: 54px;
    border-radius: 5px;
    font-size: 22px;
    text-align: center;
    line-height: 58px;
    margin-top: 40px;
    cursor: pointer;
    background-color: #f4f4f4;
    color: #b2b5b7;
  }

  .popup_login_button_active {
    color: #ffffff;
    background-color: #DE0005;
  }

  .popup_login_button_login a {
    display: block;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 20px;
    color: #1f1f20;
    margin-top: 10px;
    cursor: pointer;
  }

  .popup_login_info {
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 18px;
    color: #999999;
    margin-top: 30px;
    text-align: left;
  }

  .popup_login_info span {
    width: 27px;
    height: 27px;
    background-color: #f45252;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    float: left;
    margin-right: 10px;
    cursor: pointer;
  }

  .popup_login_info a {
    color: #999999;
    float: right;
    padding-left: 15px;
  }

  .popup_login_info a:last-child {
    border-right: 1px solid #a0a0a0;
    padding-right: 15px;
  }

  .popup_login_title {
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    text-align: center;
    color: #666666;
    margin-top: 90px;
  }

  .popup_login_list {
    width: 270px;
    height: 64px;
    margin: 40px auto;
    display: flex;
    justify-content: space-around;
  }

  .popup_login_list a {
    display: block;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: #dddddd;
    line-height: 64px;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
  }

  .popup_login_list a i {
    font-size: 30px;
    padding-right: 0 !important;
  }
  .agreen{
    font-size: 14px;
    color: #999999;
    text-align: left;
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PopupLogin.vue